var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-modal-wrapper"},[_c('div',{staticClass:"base-modal-backdrop",on:{"click":_vm.onBackdropClick}}),_c('div',{staticClass:"base-modal-content",style:({width:_vm.containerWidth})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }